<template>
    <article class="message  message-error  is-danger">
        <!--<div class="message-header" >-->
            <!--<p>Invalid token</p>-->
            <!--<button class="delete" @click="hideDanger" aria-label="delete"></button>-->
        <!--</div>-->
        <div class="message-body">
            <div class="columns">
                <div class="column  is-1 has-text-centered"><span class="icon"><i class="fas fa-exclamation-circle fa-2x"></i></span></div>
                <div class="column">
                    <div v-html="messageContent"></div>
                    <div v-if="reloadButton"><a href="" @click="reConnect()">Reconnect</a></div>
                </div>
            </div>
        </div>
    </article>
</template>

<script>
export default {
  name: 'message-error',
  props: ['messageContent', 'reloadButton'],
  mounted () {

  },
  data () {
    return {}
  },
  methods: {
    hideDanger () {
      this.$store.commit('hideDanger', false)
    },
    reConnect () {
      window.location.reload()
    }
  },
  computed: {}
}
</script>
